<template>
  <!-- Thin wrapper over PrimeVue Checkbox, the design system's public API for checkboxes. Forwards every
       prop (incl. v-model), event, and slot. Theming lives in preset.js. Use this, not primevue/checkbox. -->
  <Checkbox v-bind="$attrs">
    <template
      v-for="(_, name) in $slots"
      #[name]="slotProps"
    >
      <slot
        :name="name"
        v-bind="slotProps"
      />
    </template>
  </Checkbox>
</template>

<script setup>
import Checkbox from 'primevue/checkbox';

defineOptions({ inheritAttrs: false });
</script>
